import type { CheckoutCustomPayload } from "@product/rosetta-sdk";
import { useCallback } from "react";

import {
  registerMixPanelParameters,
  trackMixPanel,
  useMixpanel,
} from "scmp-app/components/mixpanel";

export const useRosettaCheckoutCustomEventHandler = () => {
  const mixpanel = useMixpanel();

  const handleCustomEvent = useCallback(
    (payload: CheckoutCustomPayload) => {
      const handleCheckoutCustomEventTracking = () => {
        const {
          eventName,
          params: { meter },
        } = payload;

        if (!eventName || !meter) return;

        switch (eventName) {
          case "meter-direct-checkout": {
            const {
              params: { action: eventAction },
            } = payload;
            if (!eventAction) return;

            registerMixPanelParameters(mixpanel.result, {
              "Metering Article Count": meter,
            });
            trackMixPanel(mixpanel.result, {
              name: "Subscription Metering",
              property: {
                "Metering Article Count": meter,
                "User Action": "Click Subscribe",
              },
            });
            break;
          }
        }
      };

      handleCheckoutCustomEventTracking();
    },
    [mixpanel.result],
  );

  return {
    handleCustomEvent,
  };
};
